module.exports = __webpack_public_path__ + "static/media/recall.ae994835.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/recollect/recall.jpg
// module id = 350
// module chunks = 0